import React from "react";
import { formatNumberWithFontWeight } from "../helpers/formatNumberWithFontWeight";

const PositionsInfo = ({ data, groupNetProfit }) => {
  const Divider = () => <div className="strategy-divider" />;

  const maxProfitValue =
    data?.maxProfit === Infinity
      ? "Unlimited"
      : formatNumberWithFontWeight(data?.maxProfit ?? "--");

  const maxLossValue =
    data?.maxLoss === Infinity
      ? "Unlimited"
      : formatNumberWithFontWeight(data?.maxLoss ?? "--");

  const breakevenValue =
    data?.breakeven !== undefined && data?.breakeven !== ""
      ? data?.breakeven
      : "--";

  const riskRewardValue =
    data?.riskReward !== undefined && data?.riskReward !== ""
      ? data?.riskReward
      : "--";

  const netPnLValue = formatNumberWithFontWeight(groupNetProfit ?? "--");

  const netPnLColor = groupNetProfit > 0 ? "#5CA81D" : "#DD6565";

  return (
    <div className="flex itmes-center p-4 gap-8 border border-t-n100 border-r-n100 border-l-n100">
      <div className="flex flex-col">
        <span className="creator-bottom-title">Max profit </span>
        <span className="pos-strategy-menu-value">{maxProfitValue}</span>
      </div>
      <Divider />
      <div className="flex flex-col">
        <span className="creator-bottom-title">Max loss</span>
        <span className="pos-strategy-menu-value">{maxLossValue}</span>
      </div>
      <Divider />
      <div className="flex flex-col w-auto">
        <span className="creator-bottom-title">Breakeven </span>
        <span className="pos-strategy-menu-value">{breakevenValue}</span>
      </div>
      <Divider />
      <div className="flex flex-col">
        <span className="creator-bottom-title">Risk/Reward</span>
        <span className="pos-strategy-menu-value">{riskRewardValue}</span>
      </div>
      <Divider />
      <div className="flex flex-col">
        <span className="creator-bottom-title">Net P&L</span>
        <span
          className="pos-strategy-menu-value"
          style={{ color: netPnLColor }}>
          {netPnLValue}
        </span>
      </div>
    </div>
  );
};

export default PositionsInfo;
